import { COUNTRY } from '@/utils/locale';
import { apiInterceptors } from '@/utils/report';
import createRequest from './createRequest';

const APP_TRANSLATION_HASH = +new Date();

// const JENKINS_PROJ_NAME = 'chatbot';

// const cdnServedPath = `https://deo.shopeemobile.com/shopee/shopee-${JENKINS_PROJ_NAME}-live-${COUNTRY}/static/translation/`;
// const buildPath = '/static/translation/';

const translationRequest = createRequest({
  // baseURL: (ENVIRONMENT || process.env.environment) === 'live'
  //   ? cdnServedPath
  //   : buildPath
  baseURL: '/static/translation/',
});

translationRequest?.interceptors?.request?.use(config => {
  config.headers.common['shopee-region'] = COUNTRY;
  // eslint-disable-next-line @typescript-eslint/ban-ts-comment
  // @ts-ignore
  config.requestStartTime = Date.now();
  return config;
});

translationRequest?.interceptors?.reponse?.use?.((response = {}) => {
  apiInterceptors(response);
  return response;
}, (err) => {
  apiInterceptors(err);
  return Promise.reject(err);
});

export const getTranslationMessage = (language) => translationRequest.get(`${language}.json?v=${APP_TRANSLATION_HASH}`).then(res => res.data);
